import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usr-followuptakeone',
  templateUrl: './usr-followuptakeone.component.html',
  styleUrls: ['./usr-followuptakeone.component.css']
})
export class UsrFollowuptakeoneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
